import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Orbe asistente con "sensacion de IA": animacion de escritura, glow y
// respuestas guiadas (front-end, sin backend). Da la impresion de un
// asistente inteligente integrado en la web.

const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M12 2.5l1.8 4.7L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.8L12 2.5z" fill="#fff"/>
    <path d="M18.5 14l.9 2.3 2.3.9-2.3.9-.9 2.3-.9-2.3-2.3-.9 2.3-.9.9-2.3z" fill="#eafff4"/>
  </svg>
);

const KNOWLEDGE = [
  {
    q: '¿Cómo pido una grúa?',
    a: 'Muy fácil: indícanos tu ubicación y destino, verás el precio y el tiempo estimado antes de confirmar. Cuando aceptas, asignamos al socio verificado más cercano y puedes seguirlo en tiempo real.',
    action: 'book',
  },
  {
    q: 'Tipos de grúa',
    a: 'Tenemos grúa para carro, grúa para moto, grúas para maquinaria y grúa niñera. Cada una con tarifa transparente según distancia y tipo de vehículo.',
    action: 'cars',
  },
  {
    q: 'Cobertura',
    a: 'Operamos en las principales ciudades de Colombia (Bogotá, Medellín, Cali, Barranquilla y más) las 24 horas, los 7 días.',
    action: null,
  },
  {
    q: 'Seguridad',
    a: 'Todos los conductores están verificados con documentos al día. Compartes tu viaje y lo sigues en vivo en el mapa de principio a fin.',
    action: null,
  },
];

const GREETING = '¡Hola! Soy el asistente de Movex. Puedo ayudarte a pedir una grúa, conocer precios y cobertura. ¿Qué necesitas?';

export default function AIAssistantOrb() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [fullText, setFullText] = useState(GREETING);
  const [typed, setTyped] = useState('');
  const [typing, setTyping] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (!open) return;
    setTyping(true);
    setTyped('');
    let i = 0;
    if (timer.current) clearInterval(timer.current);
    timer.current = setInterval(() => {
      i += 2;
      setTyped(fullText.slice(0, i));
      if (i >= fullText.length) {
        clearInterval(timer.current);
        setTyping(false);
      }
    }, 18);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, [fullText, open]);

  const ask = (item) => {
    setFullText(item.a);
    if (item.action === 'book') setTimeout(() => navigate('/login'), 1400);
    if (item.action === 'cars') {
      const el = document.getElementById('car-types');
      if (el && el.scrollIntoView) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 1400);
    }
  };

  return (
    <div className="ai-orb-wrap">
      {open ?
        <div className="ai-panel" role="dialog" aria-label="Asistente Movex">
          <div className="ai-panel-head">
            <div className="ai-panel-avatar"><SparkleIcon /></div>
            <div style={{ flex: 1 }}>
              <div className="ai-panel-title">Asistente Movex IA</div>
              <div className="ai-panel-sub"><span className="ai-dot" /> En línea · responde al instante</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              aria-label="Cerrar"
              style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}
            >×</button>
          </div>
          <div className="ai-panel-body">
            <div className="ai-msg">
              {typed}
              {typing ? <span className="ai-typing-cursor" /> : null}
            </div>
            <div className="ai-chips">
              {KNOWLEDGE.map((k, i) => (
                <button key={i} className="ai-chip" onClick={() => ask(k)}>{k.q}</button>
              ))}
            </div>
          </div>
        </div>
        : null}
      <button
        className="ai-orb"
        aria-label="Abrir asistente Movex"
        onClick={() => { setOpen((o) => !o); if (!open) setFullText(GREETING); }}
      >
        <SparkleIcon />
      </button>
    </div>
  );
}
